import CSVGenerator,
{
    exportFieldworkReportToXLS,
    exportInteractionsReportToXLS,
    exportTableToXLS
} from './CSVGenerator';

export default {
    CSVGenerator,
    exportFieldworkReportToXLS,
    exportInteractionsReportToXLS,
    exportTableToXLS
}